// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-content {
  min-height: calc(var(--d-spacing-double) * 2.5);
  width: 100%;
  margin: 0;
  background-color: white;
}

.header-content-container {
  padding: var(--d-spacing-double) var(--d-spacing-single);
  display: flex;
  align-items: center;
}

.title {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.chevron-icon {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  height: 23px;
  width: 28px;
}

.options {
  display: grid;
  grid-template-columns: auto 1fr;
  padding: var(--d-spacing-double);
}

.grid-container {
  padding: var(--d-spacing-double);
}

.divider-line {
  margin: 0 var(--d-spacing-single);
  border-bottom: 1px solid #cac4d0;
}

.description {
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  hyphens: none;
}

.toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: calc(var(--d-spacing-double) + 6px) calc(var(--d-spacing-double) + 6px) calc(var(--d-spacing-double) + 6px) calc(var(--d-spacing-single) - 2px);
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--d-spacing-double) calc(var(--d-spacing-double) * 2) var(--d-spacing-double) var(--d-spacing-double);
}

.chev-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--d-spacing-single);
}

.text-container {
  padding: var(--d-spacing-double) 0;
}

ion-toggle {
  --track-background: var(--ion-color-light);
}`, "",{"version":3,"sources":["webpack://./src/app/chatbot/pages/chatbot-settings/chatbot-settings.page.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACE,+CAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;AADF;;AAIA;EACE,wDAAA;EACA,aAAA;EACA,mBAAA;AADF;;AAIA;ECdI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDaF,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;AAEF;;AACA;ECtBI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDqBF,YAAA;EACA,WAAA;AAKF;;AAFA;EACE,aAAA;EACA,+BAAA;EACA,gCAAA;AAKF;;AAFA;EACE,gCAAA;AAKF;;AAFA;EACI,iCAAA;EACA,gCAAA;AAKJ;;AAFA;ECfI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDcF,aAAA;AAQF;;AALA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wJAAA;AAQF;;AALA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kHAAA;AAQF;;AALA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;AAQF;;AALA;EACE,kCAAA;AAQF;;AALA;EACE,0CAAA;AAQF","sourcesContent":["@import \"../../../../mixins\";\n\n.header-content {\n  min-height: calc(var(--d-spacing-double) * 2.5);\n  width: 100%;\n  margin: 0;\n  background-color: white;\n}\n\n.header-content-container {\n  padding: var(--d-spacing-double) var(--d-spacing-single);\n  display: flex;\n  align-items: center;\n}\n\n.title {\n  @include h1-style;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n}\n\n.chevron-icon {\n  @include h1-style;\n  height: 23px;\n  width: 28px;\n}\n\n.options {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  padding: var(--d-spacing-double);\n}\n\n.grid-container {\n  padding: var(--d-spacing-double);\n}\n\n.divider-line {\n    margin: 0 var(--d-spacing-single);\n    border-bottom: 1px solid #cac4d0;\n}\n\n.description {\n  @include p2-style;\n  hyphens: none;\n}\n\n.toggle-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: calc(var(--d-spacing-double) + 6px) calc(var(--d-spacing-double) + 6px) calc(var(--d-spacing-double) + 6px) calc(var(--d-spacing-single) - 2px);\n}\n\n.icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--d-spacing-double) calc(var(--d-spacing-double) * 2) var(--d-spacing-double) var(--d-spacing-double);\n}\n\n.chev-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--d-spacing-single);\n}\n\n.text-container {\n  padding: var(--d-spacing-double) 0;\n}\n\nion-toggle {\n  --track-background: var(--ion-color-light);\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
